import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import MessageFormValidate from "./MessageFormValidate";

const ConfirmModal = props => {
  const {
    isOpen,
    toggle,
    titleHeader,
    titleBody,
    isHaveNote,
    notePlateHolder,
    textBtnCancel,
    textBtnConfirm,
    onConfirm,
    isDisableButton,
    isRequireNote,
  } = props;

  const [isError, setIsError] = useState(false);
  const { t } = useTranslation("common");
  const inputArea = useRef(null);

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen]);

  return (
    <Modal
      size="lg"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>{titleHeader}</ModalHeader>
        {(titleBody || isHaveNote) && (
          <ModalBody>
            <span style={{ fontSize: "15px" }}>{titleBody}</span>
            {isHaveNote && (
              <React.Fragment>
                <textarea
                  className={
                    `form-control mt-3 ` + (isError ? "is-invalid" : "")
                  }
                  ref={inputArea}
                  id="commentmessage-input"
                  placeholder={notePlateHolder}
                  rows="3"
                ></textarea>
                {isError && (
                  <MessageFormValidate
                    error={`${t("requiredInput")} ${titleBody}`}
                  />
                )}
              </React.Fragment>
            )}
          </ModalBody>
        )}
        <ModalFooter>
          <Button
            type="button"
            color="danger"
            disabled={isDisableButton}
            className="me-2 btn-label"
            onClick={toggle}
          >
            <i className="bx bx-x label-icon" />
            {textBtnCancel ? textBtnCancel : "Bỏ qua"}
          </Button>
          <Button
            type="button"
            color="success"
            className="me-2 btn-label"
            disabled={isDisableButton}
            onClick={() => {
              if (inputArea.current) {
                if (isRequireNote) {
                  if (inputArea.current.value.trim() === "") {
                    setIsError(true);
                  } else {
                    setIsError(false);
                    console.log("textArea", inputArea.current.value);
                    onConfirm && onConfirm(inputArea.current.value);
                  }
                } else {
                  onConfirm && onConfirm(inputArea.current.value);
                }
              } else {
                onConfirm && onConfirm();
              }
            }}
          >
            <i className="bx bx-check label-icon" />
            {textBtnConfirm ? textBtnConfirm : "Đồng ý"}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  isHaveNote: PropTypes.bool,
  isRequireNote: PropTypes.bool,
  titleHeader: PropTypes.string,
  titleBody: PropTypes.string,
  textBtnCancel: PropTypes.string,
  textBtnConfirm: PropTypes.string,
  notePlateHolder: PropTypes.string,
  isDisableButton: PropTypes.bool,
  onConfirm: PropTypes.func,
};

ConfirmModal.defaultProps = {
  isDisableButton: false,
  isRequireNote: true,
};

export default ConfirmModal;
